export enum ErrorType {
  VariantSelectionMissing = 'VariantSelectionMissing',
  ApparelSizeMissing = 'ApparelSizeMissing',
}

export type VariantSelectionError = {
  productID: string;
  error: ErrorType;
};

export const getErrorMessage = (errorType: ErrorType): string => {
  switch (errorType) {
    case ErrorType.VariantSelectionMissing:
      return 'Please select at least one product to add to your collection.';
    case ErrorType.ApparelSizeMissing:
      return 'Please select a size.';
    default:
      return 'Please make a selection.';
  }
};
